import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Box,
  Divider,
} from '@mui/material';
import { FaBell } from "react-icons/fa";

function Activity({ activities }) {
  return (
    <Card sx={{ height: '100%', boxShadow: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box sx={{ width: 4, height: 24, bgcolor: '#ec4899', borderRadius: 1, mr: 1.5 }} />
          <Typography variant="h6" fontWeight="bold">Recent Activity</Typography>
        </Box>
        <Box sx={{ width: '100%', height: 280, overflowY: 'auto', pr: 1 }}>
          <List sx={{ width: '100%', bgcolor: 'background.paper', p: 0 }}>
            {activities && activities.length > 0 ? (
              activities.map((act, index) => (
                <React.Fragment key={act.id || index}>
                  <ListItem alignItems="flex-start" sx={{ px: 0, py: 1 }}>
                    <ListItemAvatar sx={{ minWidth: 40, mr: 1 }}>
                      <Avatar sx={{ bgcolor: 'rgba(236, 72, 153, 0.1)', color: '#ec4899', width: 32, height: 32, fontSize: '0.9rem' }}>
                        {/* If act.icon is a component, render it, else fallback */}
                        {act.icon || <FaBell />}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="body2" fontWeight="600" sx={{ lineHeight: 1.2, mb: 0.5 }}>
                          {act.title}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          component="span"
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontSize: '0.7rem' }}
                        >
                          {new Date(act.timestamp).toLocaleString('en-US', {
                            month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
                          })}
                        </Typography>
                      }
                    />
                  </ListItem>
                  {index < activities.length - 1 && <Divider component="li" sx={{ my: 0 }} />}
                </React.Fragment>
              ))
            ) : (
              <ListItem>
                <ListItemText
                  primary="No recent activity found."
                  sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }}
                />
              </ListItem>
            )}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
}

export default Activity;